/* eslint-disable @typescript-eslint/ban-ts-ignore */

import store from '../../dataStore/common-store'
import isFirefox from './isFirefox'
import isChrome from './isChrome'
import isMediaStreamTrack from './isMediaStreamTrack'
import { setWebcam } from '../../dataStore/actions/setup/setupActions'

const Browser = {
  CHROME: 'CHROME',
  FIREFOX: 'FIREFOX',
  UNAVAILABLE: 'UNAVAILABLE'
}

/**
 * Does the user's browser support screensharing
 * @returns {Browser}
 */
export const checkScreenshareImplementation = () => {

  if (isChrome()) return Browser.CHROME
  if (isFirefox()) return Browser.FIREFOX
  return Browser.UNAVAILABLE

}

/**
 * Creates a MediaStreamTrack if the browser supports it
 * @returns {Promise[MediaStreamTrack | null]}
 */
export default async function getUserScreen () {

  let stream

  switch (checkScreenshareImplementation()) {

    case Browser.CHROME:
      // @ts-ignore
      stream = await window.navigator.mediaDevices.getDisplayMedia()
      break
    case Browser.FIREFOX:
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          // @ts-ignore
          mediaSource: 'screen'
        }
      })
      break
    default:
      return null

  }

  const [ track ] = stream.getTracks()

  if (!track || !isMediaStreamTrack(track)) return null

  // TODO: Fix by moving this to an event listener epic
  // @ts-ignore
  track.onended = () => store.dispatch(setWebcam())
  return track

}
